import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import FrontierMark from "@/components/FrontierMark";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash.replace(/^#/, "");
        const params = new URLSearchParams(hash);
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                await Auth.session(sessionId);
                await refresh();
                window.history.replaceState({}, "", "/admin");
                navigate("/admin", { replace: true });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center">
                <div className="mb-6 flex justify-center">
                    <FrontierMark size="lg" />
                </div>
                <div className="overline-cobalt mb-3">[Auth · Exchanging]</div>
                <p
                    style={{
                        fontFamily: "'Fraunces', serif",
                        fontStyle: "italic",
                        fontSize: 28,
                        color: "var(--ink)",
                    }}
                >
                    Signing you in…
                </p>
            </div>
        </div>
    );
}
